var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "custom-callout",
        {
          attrs: { controlled: "", "has-toggle": "", opened: _vm.value.opened },
          on: {
            "click:open": function($event) {
              return _vm.toggle()
            }
          },
          scopedSlots: _vm._u([
            {
              key: "edition",
              fn: function() {
                return [
                  _c("div", { staticClass: "bg-secondary-3 p-2" }, [
                    _vm.isHistory
                      ? _c(
                          "div",
                          { staticClass: "bg-white p-3 rounded mr-0 ml-0" },
                          [
                            _c("div", { staticClass: "mb-3" }, [
                              _c("i", {
                                staticClass: "fas fa-history text-green"
                              }),
                              _c("b", { staticClass: "ml-2" }, [
                                _vm._v(" Historial del Estatus ")
                              ])
                            ]),
                            _c("history", {
                              attrs: { data: _vm.history },
                              on: {
                                clean: _vm.initHistory,
                                load: _vm.getHistory
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ])
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _c(
            "div",
            { staticClass: "row d-flex align-items-center py-2 pr-3" },
            [
              _c(
                "div",
                { staticClass: "col-12 col-md" },
                [
                  _c("div", { staticClass: "data-name" }, [_vm._v("Estatus:")]),
                  _c("custom-balloon", {
                    attrs: {
                      "background-color": _vm.value.status?.color,
                      dot: "",
                      text: _vm.value.status?.name
                    }
                  })
                ],
                1
              ),
              _c("div", { staticClass: "col-12 col-md" }, [
                _c("div", { staticClass: "data-name" }, [
                  _vm._v("Estudiante:")
                ]),
                _c("div", [
                  _vm._v(
                    " " +
                      _vm._s(_vm._f("empty")(_vm.value.student?.id)) +
                      " - " +
                      _vm._s(_vm._f("empty")(_vm.value.student?.name)) +
                      " "
                  )
                ])
              ]),
              _c("div", { staticClass: "col-12 col-md" }, [
                _c("div", { staticClass: "data-name" }, [_vm._v("Servicio:")]),
                _c("div", [
                  _vm._v(
                    _vm._s(_vm._f("empty")(_vm.value.disciplineType?.name))
                  )
                ])
              ]),
              _c("div", { staticClass: "col-12 col-md" }, [
                _c("div", { staticClass: "data-name" }, [
                  _vm._v("Fecha de Servicio:")
                ]),
                _c("div", [
                  _vm._v(_vm._s(_vm._f("date")(_vm.value.serviceDate)))
                ])
              ]),
              _c(
                "div",
                { staticClass: "col-12 col-md-2 d-flex justify-content-end" },
                [_c("drop-down", { attrs: { items: _vm.actions } })],
                1
              ),
              _c("div", { staticClass: "w-100 px-3" }, [_c("hr")]),
              _c("div", { staticClass: "col-12 col-md" }, [
                _c("div", { staticClass: "data-name" }, [
                  _vm._v("Hora de Servicio:")
                ]),
                _c("div", [
                  _vm._v(_vm._s(_vm._f("time")(_vm.value.serviceStartTime)))
                ])
              ]),
              _c("div", { staticClass: "col-12 col-md" }, [
                _c("div", { staticClass: "data-name" }, [_vm._v("Proveedor:")]),
                _c("div", [
                  _vm._v(_vm._s(_vm._f("empty")(_vm.value.company?.name)))
                ])
              ]),
              _c("div", { staticClass: "col-12 col-md" }, [
                _c("div", { staticClass: "data-name" }, [
                  _vm._v("Especialista:")
                ]),
                _c("div", [
                  _vm._v(_vm._s(_vm._f("empty")(_vm.value.specialist?.name)))
                ])
              ]),
              _c("div", { staticClass: "col-12 col-md" }, [
                _c("div", { staticClass: "data-name" }, [
                  _vm._v("Montor a Reclamar:")
                ]),
                _c("div", [
                  _vm._v(_vm._s(_vm._f("price")(_vm.value.costAmount)))
                ])
              ]),
              _c("div", { staticClass: "col-12 col-md-2" })
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }